export const closingOf = (className: string): string => `${className}__close`

export const classlist = (classMap: Record<string, boolean>): string =>
  Object
    .entries(classMap)
    .filter(([, include]) => include)
    .map(([className, ]) => className)
    .join(' ')
